import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useCallback } from 'react';

export default () => {
  const navHistory = useSelector((state) => state.navHistory);
  const history = useHistory();
  const navigateToClosestRoot = useCallback(() => {
    const closestRootPage = navHistory.find(
      (path) => path.split('/').length === 2,
    );
    history.push(closestRootPage || '/overview');
  }, [navHistory, history]);

  return {
    navigateToClosestRoot,
  };
};
